import { render, staticRenderFns } from "./role-ope.vue?vue&type=template&id=2c0cdcbf&scoped=true&"
import script from "./role-ope.vue?vue&type=script&lang=js&"
export * from "./role-ope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0cdcbf",
  null
  
)

export default component.exports